<template>
    <div id="email-receipt">
        <div class="field">
            <div id="email-label">Email Address</div>
            <input id="email" ref="email" v-model.trim="$v.email.$model" v-focus type="email"
                   @blur="$v.email.$touch" :class="emailFieldClass" class="input-secondary" />
            <div v-if="$v.email.$dirty && !$v.email.required && readyToSend" class="error-message">Email is required.</div>
            <div v-if="$v.email.$dirty && !$v.email.email && readyToSend" class="error-message">Invalid email address.</div>
        </div>
        <!-- Temporarily hiding to simplify the interface. -->
        <!--<div class="field">
            <div>Memo on Check<span class="optional">Optional</span></div>
            <input id="memo" v-model="memo" type="text" class="input-secondary" />
        </div>-->
        <div id="button-wrapper" class="field">
            <button id="send" @click="sendEmailReceipt" :class="sendButtonClass">Send</button>
            <button id="cancel" @click="cancel" class="button-secondary">Cancel</button>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import { mapGetters, mapMutations } from "vuex";
    import { required, email } from 'vuelidate/lib/validators';
    import { sweetAlert2 } from "../mixins/sweet-alert2";
    import { showBlocker } from "../mixins/show-blocker";
    import { appSettings } from "../mixins/app-settings";

    export default {
        name: "EmailReceipt",
        mixins: [sweetAlert2, showBlocker, appSettings],
        props: {
            siteId: String,
            accountId: String,
            checkId: String,
            paymentId: String
        },
        data() {
            return {
                email: undefined,
                memo: null,
                readyToSend: false
            }
        },
        validations: {
            email: {
                required,
                email
            }
        },
        computed: {
            ...mapGetters([
                "balance"
            ]),
            emailFieldClass() {
                return !this.$v.email.$invalid ? "input-valid" : "input-invalid";
            },
            sendButtonClass() {
                return !this.$v.$invalid ? "button-primary" : "button-secondary-selected";
            }
        },
        methods: {
            ...mapMutations([
                "setLoadingStatus"
            ]),
            cancel() {
                this.$emit("cancel");
            },
            async sendEmailReceipt() {
                // Start displaying the actual error message the first time
                // the Send button is tapped.
                this.readyToSend = true;

                if (!this.$v.$invalid) {
                    const vm = this;
                    this.swalConfirm(async () => {
                        this.startProgressIndicator();

                        const requestData = {
                            siteId: this.siteId,
                            accountId: this.accountId,
                            checkId: this.checkId,
                            paymentId: this.paymentId,
                            email: this.email,
                            memo: this.memo
                        };

                        await axios
                            .post(vm.getApiBaseUrl() + "/payment/emailreceipt", requestData)
                            .then(() => {
                                this.$emit("sentEmailReceipt")
                            })
                            .catch(error => {
                                if (error.data && error.data.errorMessage) {
                                    console.error(error.data.errorMessage);
                                }
                                else {
                                    console.error(error);
                                }
                                this.swalError("1017");
                            })
                            .finally(() => {
                                this.stopProgressIndicator();
                                this.finalize();
                            });

                    }, `Email receipt to ${this.email}?`, "Confirm email address", "OK");
                }
            },
            async finalize() {
                if (this.balance > 0) {
                    return;
                }

                const requestUrl = this.getApiBaseUrl() + "/check/finalize/" + this.siteId + "/" + this.accountId + "/" + this.checkId;

                await axios
                    .post(requestUrl)
                    .catch(error => {
                        if (error.response &&
                            error.response.data &&
                            error.response.data.errorMessage) {
                            console.error(error.response.data.errorMessage);
                        }
                        else {
                            console.error(error);
                        }
                    });
            }
        },
        activated() {
            this.$refs.email.focus();
        }
    }
</script>

<style scoped>
    #email-receipt {
        font-weight: bold;
        background-color: var(--white);
        margin-top: 10px;
        padding: 10px 20px 0 20px;
        text-align: left;
    }

        #email-receipt #email-label {
            margin-left: 5px;
        }

        #email-receipt input {
            display: block;
            margin: 5px 0 0 0;
            box-sizing: border-box;
            width: 100%;
            margin-bottom: 5px;
        }

    .optional {
        margin-left: 5px;
        color: var(--text-gray);
        font-size: 14px;
        font-weight: normal;
    }

    .field:nth-child(3) {
        margin: 0 auto;
    }

    .field button {
        margin: 10px 0 10px 0;
    }

    #button-wrapper {
        display: flex;
        flex-direction: row;
    }

    #send {
        flex-grow: 1;
    }

    #cancel {
        margin-left: 10px;
        width: 100px;
    }
</style>